import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import OverView from "./components/OverView";
import TimelineSection from "./components/TimelineSection";
import PhaseSection from "./components/PhaseSection";
import FeedSection from "./components/FeedSection";
import ClueSection from "./components/ClueSection";
import CommunitySection from "./components/CommunitySection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <TopNav />
      <main>
        <Hero />
        <OverView />
        <TimelineSection />
        <PhaseSection />
        <FeedSection />
        <ClueSection />
        <CommunitySection />
      </main>
      <Footer />
    </div>
  );
}